<template>
  <div class="container">
    <!-- 提示框 -->
    <div v-if="!passwordEntered" class="password-alert">
      <p> WEB 界面登陆主机</p>
    </div>

    <!-- 集控平台部分，只有在密码输入后才显示 -->
    <div v-if="passwordEntered">
      <div
        style="width: 100%;height: 100px;font-size: 30px;font-weight: 700;color: #fff;background-image: url('../assets/title.png');text-align: center;margin-bottom: 100px;">
        集控平台
      </div>
      <div style="color: #fff;width: 50%;margin: 0 auto;">
        <div style="width: 100%;display: flex;justify-content: space-between;margin-bottom: 100px;flex-wrap:wrap">
          <button @click=" send('relay0 on'), send('relay5 on'),micVol=0,lineVol=0;">关闭扩声</button>
          <button @click=" send('relay3 on'), send('relay6 on'),micVol=15,lineVol=-20;">开启扩声</button>
          <button @click=" send('relay2 off')">开启静音</button>
          <button @click=" send('relay3 off')">关闭静音</button>
          <button @click="downloadJson">保存配置</button>

          <button @click="triggerFileInput">导入配置</button>
          <input type="file" ref="fileInput" style="display: none;" @change="handleFileChange" />
          <button @click="networkUpgrade">网络升级</button>
          <button @click="startRandomProgress">一键自检</button>
          <button @click="startRandomProgress">恢复出厂设置</button>
          <!-- <button>网络升级</button> -->
        </div>

        <!-- <div v-show="isCheck" style="margin-bottom: 15px;">正在自检中</div> -->
        <div v-show="isCheck" style="width: 90%;display: flex; justify-content: space-between;">
          <input style="width: 80%;" v-model="progress" type="range" max="100" />
          <span>{{progress}}%</span>
        </div>

        <div style="height: 100px;"></div>
        <div style="margin-bottom: 15px;">MicVol（话筒音量）</div>
        <div style="width: 90%;display: flex; justify-content: space-between;">
          <input style="width: 80%;" v-model="micVol" type="range" max="20" step="5" @input="onMicVolChange" />
          <span>{{micVol}}</span>
        </div>

        <div style="height: 100px;"></div>
        <div style="margin-bottom: 15px;">LineVol（电子音量）
        </div>
        <div style="width: 90%;display: flex; justify-content: space-between;">
          <input style="width: 80%;" v-model="lineVol" type="range" :min="-80" :max="0" step="20"
            @input="onTineVolChange" />
          <span>{{lineVol >= 80 ? '79' : lineVol}}</span>
        </div>
      </div>
    </div>

    <!-- 密码输入框 -->
    <div v-if="!passwordEntered" class="password-container">
      <input type="password" v-model="password" placeholder="请输入密码" />
      <div style="margin-top: 100px;">
        <button style="width: 150px;" @click="checkPassword">登陆主机</button>
      </div>
    </div>
  </div>
</template>



<script>
  import { ref, getCurrentInstance } from 'vue';
  //  import { useRouter } from 'vue-router';
  export default {
    setup() {
      const jsonData = ref(null);  // 用来存储导入的 JSON 数据
      const micVol = ref(0);
      const lineVol = ref(0);
      const instance = getCurrentInstance(); // 获取组件实例
      const passwordEntered = ref(false);
      const password = ref('');
      const isCheck = ref(false);
      let intervalId = null;
      const progress = ref(0);
      //  const router = useRouter();
      const startRandomProgress = () => {
        if (!intervalId && !isCheck.value) {
          isCheck.value = true
          progress.value = 0
          intervalId = setInterval(() => {
            // 生成一个0到10之间的随机数
            const randomIncrement = Math.floor(Math.random() * 30);
            // 更新进度条的值

            progress.value = Math.min(progress.value + randomIncrement, 100);

            if (progress.value === 100) {
              stopRandomProgress();
            }
          }, 150);
        }
      }

      const stopRandomProgress = () => {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
          setTimeout(() => {
            isCheck.value = false
            //alert("自检完成，无异常")

          }, 500)
        }
      }

      const checkPassword = () => {
        console.log(password)
        if (password.value == "123456") {
          passwordEntered.value = true; // 正确使用 .value 来修改 ref 的值
        } else {
          alert('密码错误');
        }
      }

      const networkUpgrade = () => {
        //  router.push(`/room`);
        window.location.href = '/room'; // 使用传统的页面跳转，重新加载页面
      };

      // 激活文件输入框
      const triggerFileInput = () => {
        const fileInput = document.querySelector('input[type="file"]');
        fileInput.click(); // 自动触发文件选择框
      };

      // 处理文件选择事件
      const handleFileChange = (event) => {
        const file = event.target.files[0];  // 获取选择的文件
        if (file && file.type === 'application/json') {
          const reader = new FileReader();

          reader.onload = () => {
            try {
              jsonData.value = JSON.parse(reader.result);  // 解析 JSON 内容
              for (var i = 0; i < jsonData.value.length; i++) {
                send(jsonData.value[i]);
              }
            } catch (error) {
              alert("文件内容不是有效的 JSON 格式");
            }
          };

          reader.readAsText(file);  // 读取文件内容
        } else {
          alert("请选择一个有效的 JSON 文件");
        }
      };

      // 生成并下载 JSON 文件
      const downloadJson = () => {
        // 创建 Blob 对象，表示数据
        var data = []

        if (micVol.value == 0) {
          data[0] = 'relay0 on';
        } else if (micVol.value == 5) {
          data[0] = 'relay1 on';
        } else if (micVol.value == 10) {
          data[0] = 'relay2 on';
        } else if (micVol.value == 15) {
          data[0] = 'relay3 on';
        } else if (micVol.value == 20) {
          data[0] = 'relay4 on';
        }

        if (lineVol.value == 0) {
          data[1] = 'relay5 on';
        } else if (lineVol.value == -20) {
          data[1] = 'relay6 on';
        } else if (lineVol.value == -40) {
          data[1] = 'relay7 on';
        } else if (lineVol.value == -50 || lineVol.value == -60) {
          data[1] = 'relay0 off';
        } else if (lineVol.value == -80) {
          data[1] = 'relay1 off';
        }



        const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });

        // 创建 URL 对象指向 Blob 对象
        const url = URL.createObjectURL(blob);

        // 创建一个 <a> 元素
        const a = document.createElement('a');
        a.href = url;
        a.download = 'config.json';  // 设置下载的文件名

        // 模拟点击下载
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // 释放 Blob URL
        URL.revokeObjectURL(url);
      };


      const onMicVolChange = () => {
        if (micVol.value == 0) {
          send('relay0 on');
        } else if (micVol.value == 5) {
          send('relay1 on');
        } else if (micVol.value == 10) {
          send('relay2 on');
        } else if (micVol.value == 15) {
          send('relay3 on');
        } else if (micVol.value == 20) {
          send('relay4 on');
        }

      };

      const onTineVolChange = () => {
        if (lineVol.value == 0) {
          send('relay5 on');
        } else if (lineVol.value == -20) {
          send('relay6 on');
        } else if (lineVol.value == -40) {
          send('relay7 on');
        } else if (lineVol.value == -50 || lineVol.value == -60) {
          send('relay0 off');
        } else if (lineVol.value == -80) {
          send('relay1 off');
        }

      };



      const send = (msg) => {
        // 随机生成 0.1 到 0.2 秒的延迟（即 100ms 到 200ms）
        const delay = Math.random() * 0.1 + 0.2;  // 延迟范围 0.1s 到 0.2s

        // 在延迟时间后执行请求
        setTimeout(() => {
          if (instance && instance.proxy) {
            console.log(msg);
            const url = '/send?deviceName=YR_ICC2000_02_34_36_47_3C_1A&productKey=a1BKFVlkMpx&topicFullName=/a1BKFVlkMpx/YR_ICC2000_02_34_36_47_3C_1A/user/get&sendMsg=' + msg;
            //    const url = '/send?deviceName=YR_ICC2000_02_37_4D_48_3E_0C&productKey=a1BKFVlkMpx&topicFullName=/a1BKFVlkMpx/YR_ICC2000_02_37_4D_48_3E_0C/user/get&sendMsg=' + msg;
            instance.proxy.$http.get(url)
              .then(data => {
                console.log(data);
              })
              .catch(error => {
                console.error("请求错误:", error);
              });
          }
        }, delay * 1000); // 转换为毫秒单位，延迟 100ms 到 200ms
      };


      return {
        micVol,
        lineVol,
        passwordEntered,
        jsonData,
        onMicVolChange,
        onTineVolChange,
        downloadJson,
        triggerFileInput,
        handleFileChange,
        password,
        checkPassword,
        isCheck,
        send,
        progress,
        startRandomProgress,
        stopRandomProgress,
        networkUpgrade
      };
    },
  };
</script>


<style scoped>
  .container {
    background-image: url('@/assets/bg.png');
    background-size: 100%;
    background-color: rgba(38, 42, 48, 1);
    padding: 10px 10px;
  }

  .password-alert {
    text-align: center;
    color: red;
    font-size: 18px;
    margin-bottom: 20px;
    padding: 10px;
    background-color: rgba(255, 0, 0, 0.2);
    border-radius: 8px;
  }

  .password-container {
    text-align: center;
    margin-top: 50px;
  }

  .password-container input {
    padding: 10px 20px;
    font-size: 18px;
    border-radius: 25px;
    border: 1px solid #ddd;
    outline: none;
    width: 60%;
    margin-bottom: 20px;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

  .password-container input:focus {
    border-color: #4caf50;
  }

  .password-container button {
    padding: 12px 25px;
    font-size: 18px;
    cursor: pointer;
    border: none;
    background-color: #4caf50;
    color: white;
    border-radius: 25px;
    width: 60%;
  }

  .password-container button:hover {
    background-color: #45a049;
  }

  .password-container input::placeholder {
    color: #888;
  }
</style>